import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.damage.predict');
import { OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-damage-predict',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.damage.predict/view.scss */
/* src/app/page.damage.predict/view.scss: no such file or directory */`],
})
export class PageDamagePredictComponent implements OnInit, AfterViewInit {
    @ViewChild('resultCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
    @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

    public models: any[] = [];
    public selectedModelId: string = '';
    public result: any = null;
    public uploadedImage: any = null;
    public isUploading: boolean = false;
    public isAnalyzing: boolean = false;
    public classNames: string[] = [];
    public isDragging: boolean = false;
    public isSavingAnnotations: boolean = false;

    public canvasWidth: number = 640;
    public canvasHeight: number = 480;

    // 이력 (이미지별 그룹)
    public historyGroups: any[] = [];
    public historyTotal: number = 0;
    public historyPage: number = 1;
    public historyDump: number = 10;
    public expandedGroups: Set<string> = new Set();

    // 동적 색상 팔레트
    private readonly HEX_PALETTE = [
        '#EF4444', '#F59E0B', '#8B5CF6', '#10B981', '#3B82F6',
        '#EC4899', '#F97316', '#14B8A6', '#84CC16', '#6366F1',
        '#F43F5E', '#0EA5E9', '#D946EF', '#22C55E', '#CA8A04'
    ];
    private readonly TEXT_PALETTE = [
        'text-red-500', 'text-amber-500', 'text-violet-500', 'text-emerald-500', 'text-blue-500',
        'text-pink-500', 'text-orange-500', 'text-teal-500', 'text-lime-600', 'text-indigo-500',
        'text-rose-500', 'text-sky-500', 'text-fuchsia-500', 'text-green-500', 'text-yellow-600'
    ];
    private readonly BG_PALETTE = [
        'bg-red-50 border-red-200', 'bg-amber-50 border-amber-200', 'bg-violet-50 border-violet-200',
        'bg-emerald-50 border-emerald-200', 'bg-blue-50 border-blue-200', 'bg-pink-50 border-pink-200',
        'bg-orange-50 border-orange-200', 'bg-teal-50 border-teal-200', 'bg-lime-50 border-lime-200',
        'bg-indigo-50 border-indigo-200', 'bg-rose-50 border-rose-200', 'bg-sky-50 border-sky-200',
        'bg-fuchsia-50 border-fuchsia-200', 'bg-green-50 border-green-200', 'bg-yellow-50 border-yellow-200'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadModels();
        await this.loadClassNames();
        await this.loadHistory();
        await this.service.render();
    }

    public ngAfterViewInit() { }

    public async loadModels() {
        const { code, data } = await wiz.call('models');
        if (code === 200) {
            this.models = data.rows;
            if (this.models.length > 0) {
                this.selectedModelId = this.models[0].id;
            }
        }
    }

    public async loadClassNames() {
        const { code, data } = await wiz.call('labels');
        if (code === 200) {
            this.classNames = data.labels;
        }
    }

    public async loadHistory(page: number = 1) {
        this.historyPage = page;
        const { code, data } = await wiz.call('prediction_history', {
            page: this.historyPage,
            dump: this.historyDump
        });
        if (code === 200) {
            this.historyGroups = data.groups;
            this.historyTotal = data.total;
        }
        await this.service.render();
    }

    public get historyTotalPages(): number {
        return Math.ceil(this.historyTotal / this.historyDump);
    }

    public toggleGroup(imageId: string) {
        if (this.expandedGroups.has(imageId)) {
            this.expandedGroups.delete(imageId);
        } else {
            this.expandedGroups.add(imageId);
        }
        this.service.render();
    }

    public isExpanded(imageId: string): boolean {
        return this.expandedGroups.has(imageId);
    }

    /** 드래그 오버 */
    public onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.isDragging) {
            this.isDragging = true;
            this.service.render();
        }
    }

    /** 드래그 떠남 */
    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        this.service.render();
    }

    /** 드롭 이벤트 처리 (결과 화면에서 드롭 시 자동 분석) */
    public async onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const hadResult = !!this.uploadedImage;
        this.isDragging = false;

        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;

        const file = files[0];
        if (!file.type.startsWith('image/')) {
            await this.service.modal.show({
                title: '알림',
                message: '이미지 파일만 업로드할 수 있습니다.',
                action: '확인',
                cancel: false
            });
            return;
        }

        // 이미 이미지가 있는 상태(결과 화면)에서 드롭하면 자동 분석
        await this.uploadFile(file, hadResult);
    }

    /** 클릭으로 파일 선택 */
    public onClickUploadZone() {
        if (this.isUploading || this.isAnalyzing || this.models.length === 0) return;
        this.fileInputRef?.nativeElement?.click();
    }

    /** 파일 인풋 변경 */
    public async onFileInputChange(event: any) {
        const files = event.target?.files;
        if (!files || files.length === 0) return;
        await this.uploadFile(files[0]);
        // 같은 파일 재선택 가능하도록 리셋
        event.target.value = '';
    }

    /** 파일 업로드 공통 로직 (autoPredict: true이면 업로드 후 자동 분석) */
    private async uploadFile(file: File, autoPredict: boolean = false) {
        if (this.models.length === 0) {
            await this.service.modal.show({
                title: '알림',
                message: '학습된 모델이 없습니다. 먼저 모델을 학습해주세요.',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.isUploading = true;
        this.result = null;
        await this.service.render();

        try {
            const fd = new FormData();
            fd.append('file', file);
            const res: any = await this.service.file.upload('/wiz/api/page.damage.predict/upload_only', fd);
            if (res && res.code === 200) {
                this.uploadedImage = res.data.image;
                this.isUploading = false;
                await this.service.render();
                setTimeout(() => this.drawImage(), 100);
                if (autoPredict) {
                    setTimeout(() => this.onPredict(), 200);
                }
            } else {
                this.isUploading = false;
                await this.service.modal.show({
                    title: '오류',
                    message: res?.data?.message || '업로드에 실패했습니다.',
                    action: '확인',
                    status: 'error',
                    cancel: false
                });
            }
        } catch (e: any) {
            this.isUploading = false;
            await this.service.modal.show({
                title: '오류',
                message: e.message || '업로드 중 오류가 발생했습니다.',
                action: '확인',
                status: 'error',
                cancel: false
            });
        }

        await this.service.render();
    }

    /** 탐지 결과 개별 삭제 */
    public async removeDetection(index: number) {
        if (!this.result || !this.result.detections) return;
        this.result.detections.splice(index, 1);
        await this.service.render();
        setTimeout(() => this.drawResult(), 50);
    }

    /** 남은 탐지 결과를 어노테이션 자료로 전송 */
    public async saveAsAnnotations() {
        if (!this.result || !this.uploadedImage || this.result.detections.length === 0) return;

        const confirmed = await this.service.modal.show({
            title: '어노테이션으로 전송',
            message: `${this.result.detections.length}개의 탐지 결과를 어노테이션 데이터로 전송합니다. 기존 어노테이션은 유지됩니다.`,
            action: '전송',
            actionBtn: 'success',
            status: 'info'
        });
        if (!confirmed) return;

        this.isSavingAnnotations = true;
        await this.service.render();

        const detections = this.result.detections.map((d: any) => ({
            class_name: d.class_name,
            bbox: d.bbox
        }));

        const { code, data } = await wiz.call('save_as_annotations', {
            image_id: this.uploadedImage.id,
            detections: JSON.stringify(detections)
        });

        this.isSavingAnnotations = false;

        if (code === 200) {
            await this.service.modal.show({
                title: '전송 완료',
                message: `${detections.length}개의 어노테이션이 저장되었습니다. 어노테이션 페이지로 이동합니다.`,
                action: '확인',
                cancel: false
            });
            this.service.href(`/damage/annotate/${this.uploadedImage.id}`);
        } else {
            await this.service.modal.show({
                title: '오류',
                message: data?.message || '어노테이션 전송에 실패했습니다.',
                action: '확인',
                status: 'error',
                cancel: false
            });
            await this.service.render();
        }
    }

    /** 업로드된 이미지에 대해 손상 분석 실행 */
    public async onPredict() {
        if (!this.uploadedImage || !this.selectedModelId) return;

        this.isAnalyzing = true;
        this.result = null;
        await this.service.render();

        const { code, data } = await wiz.call('predict_existing', {
            image_id: this.uploadedImage.id,
            model_id: this.selectedModelId
        });

        if (code === 200) {
            this.result = data.data;
            await this.service.render();
            setTimeout(() => this.drawResult(), 100);
        } else {
            await this.service.modal.show({
                title: '오류',
                message: data?.message || '분석에 실패했습니다.',
                action: '확인',
                status: 'error',
                cancel: false
            });
        }

        this.isAnalyzing = false;
        await this.loadHistory();
        await this.service.render();
    }

    /** 이력에서 이미지 클릭 시 해당 분석 결과 로드 */
    public async loadFromHistory(group: any) {
        const imageId = group.image_id;
        const image = { id: imageId, original_filename: group.original_filename };
        this.uploadedImage = image;
        this.result = {
            image_id: imageId,
            detections: group.detections.map((d: any) => ({
                class_name: d.class_name,
                confidence: d.confidence,
                bbox: [d.bbox_x1, d.bbox_y1, d.bbox_x2, d.bbox_y2]
            }))
        };
        await this.service.render();
        setTimeout(() => this.drawResult(), 100);
    }

    /** 업로드된 이미지를 캔버스에 표시 (박스 없음) */
    private drawImage() {
        if (!this.canvasRef || !this.uploadedImage) return;
        const canvas = this.canvasRef.nativeElement;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            ctx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight);
        };
        img.src = `/wiz/api/page.damage.predict/image?id=${this.uploadedImage.id}&t=${Date.now()}`;
    }

    /** 분석 결과 이미지 + 바운딩박스 캔버스에 표시 */
    private drawResult() {
        if (!this.canvasRef || !this.result || !this.uploadedImage) return;
        const canvas = this.canvasRef.nativeElement;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            ctx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight);

            for (const det of this.result.detections) {
                const [x1, y1, x2, y2] = det.bbox;
                const color = this.getHexColor(det.class_name);

                ctx.strokeStyle = color;
                ctx.lineWidth = 3;
                ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);

                const label = `${det.class_name} ${(det.confidence * 100).toFixed(1)}%`;
                ctx.font = 'bold 14px sans-serif';
                const metrics = ctx.measureText(label);
                ctx.fillStyle = color;
                ctx.fillRect(x1, y1 - 20, metrics.width + 8, 20);
                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(label, x1 + 4, y1 - 6);
            }
        };
        img.src = `/wiz/api/page.damage.predict/image?id=${this.uploadedImage.id}&t=${Date.now()}`;
    }

    /** 손상 유형 요약 텍스트 생성 */
    public getDetectionSummary(detections: any[]): string {
        const counts: { [key: string]: number } = {};
        for (const d of detections) {
            counts[d.class_name] = (counts[d.class_name] || 0) + 1;
        }
        return Object.entries(counts).map(([k, v]) => `${k} ${v}건`).join(', ');
    }

    public getHexColor(cls: string): string {
        const i = this.classNames.indexOf(cls);
        if (i < 0) return '#9CA3AF';
        return this.HEX_PALETTE[i % this.HEX_PALETTE.length];
    }

    public getClassColor(cls: string): string {
        const i = this.classNames.indexOf(cls);
        if (i < 0) return 'text-zinc-500';
        return this.TEXT_PALETTE[i % this.TEXT_PALETTE.length];
    }

    public getClassBgColor(cls: string): string {
        const i = this.classNames.indexOf(cls);
        if (i < 0) return 'bg-zinc-50 border-zinc-200';
        return this.BG_PALETTE[i % this.BG_PALETTE.length];
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    public thumbnailUrl(imageId: string): string {
        return `/wiz/api/page.damage.predict/image?id=${imageId}`;
    }
}

export default PageDamagePredictComponent;